import React from "react";
import { dlsDeleteIcon } from "../styles/FoodItem.scss";

export const DeleteIconFilled = React.memo(function DeleteIconFilled() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            className={dlsDeleteIcon}
        >
            <path
                fill="#02060C"
                d="M1.997 3.775h8.006c.44 0 .8-.36.8-.8 0-.44-.36-.8-.8-.8h-1.38l-.479-.54c-.34-.39-.83-.61-1.35-.61H5.186c-.52 0-1.01.22-1.35.61l-.479.54h-1.36c-.44 0-.799.36-.799.8 0 .44.36.8.8.8Zm7.377 4.78.6-2.35v-.004c.04-.172.127-.539-.14-.886-.27-.34-.65-.34-.84-.34H3.026c-.18 0-.56 0-.83.33-.27.34-.19.71-.15.89l.53 2.29.014.057c.222.976.357 1.571.896 1.993.55.44 1.17.44 2.21.44h.579c1.01 0 1.62 0 2.159-.42.54-.43.69-1.019.939-1.997v-.003Z"
            />
        </svg>
    );
});
